import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CognitoService } from '../service/cognito.service';
import { RoleService } from '../service/role.service';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DispatchDriverBlockGuard implements CanActivate {
  constructor(
    private cognitoService: CognitoService,
    private roleService: RoleService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      await this.cognitoService.confirmValidUser();
      await this.cognitoService.getUserType();
      const roles = await this.roleService.getRoles();
      const isOperator = this.cognitoService.userType === environment.users.maintenance;
      const currentRole = this.cognitoService.userInfos?.attributes?.['custom:current_role'] || '';
      const isDispatchOrDriver =
        roles.includes(environment.users.role.dispatch) ||
        roles.includes(environment.users.role.driver) ||
        currentRole === environment.users.role.dispatch ||
        currentRole === environment.users.role.driver;

      if (isOperator && isDispatchOrDriver) {
        this.router.navigate(['/dashboard']);
        return false;
      }
      return true;
    } catch (error) {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
